/**
 * `/_/events/kiosk`: an event's door kiosk (F-115). Public, no session, no app shell. The device's token
 * arrives once in the fragment (`#t=...`) and is kept in `localStorage` by the page.
 */
export const EVENT_KIOSK_PATH = '/_/events/kiosk'

export const isEventKioskPath = (path: string): boolean => path === EVENT_KIOSK_PATH || path === `${EVENT_KIOSK_PATH}/`

/**
 * `/_/events/{id}/check-in`: an event's door straight away, without its space (F-115). An organizer who
 * cannot open the Events space still runs the door: being an organizer is the authorization. Needs a session.
 */
const EVENT_CHECK_IN_RE = /^\/_\/events\/([0-9a-f-]{36})\/check-in\/?$/i

export const eventCheckInPath = (eventId: string): string => `/_/events/${eventId}/check-in`

export const eventCheckInIdOf = (path: string): string | null => EVENT_CHECK_IN_RE.exec(path)?.[1] ?? null

/** `/_/events/organizing`: "Eventos que organizo", the events the person organizes, with the way to each door. */
export const ORGANIZING_EVENTS_PATH = '/_/events/organizing'
